














/* eslint-disable import/no-dynamic-require */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Header from '@/components/layout/Header.vue';

@Component({
  components: {
    Header,
  },
})

export default class App extends Vue {
  counter = 0;

  language = 'de'; // change when needed using a toggle button in the navbar

  languagePool = ['de', 'en'];

  // eslint-disable-next-line global-require
  text = require(`@/text_${this.language}.json`);

  displayWarning = true;

  switchLanguage():void {
    this.counter = (this.counter + 1) % this.languagePool.length;
    this.language = this.languagePool[this.counter];
  }
}
